import authRules from '../authRules.js';

const editStatus = (user) => {
  const { status } = user.securityLevels;
  if (status >= authRules.editStatus.status) {
      return true;
  } else {
      return false;
    }
  }


export default editStatus;
